import { patch } from './utils';

export async function confirmOrderExchangeApi({ data, id }) {
  return patch(`/orders-exchange/${id}/approve`, data);
}

export async function cancelOrdersExchangeApi({ id, data }) {
  return patch(`/orders-exchange/${id}/cancel`, data);
}

export const changePaymentToBankApi = ({ id }) =>
  patch(`/orders-exchange/${id}/change-to-bank-transfer`);
